import { useEffect, useRef } from 'react';
import { FilterOption, FilterOptions } from '@/api';
import { useOpenApi } from '../providers/open-api-provider';
import { USER_FILTER_OPTIONS_QUERY_KEY } from './common-query-keys';
import {
    FILTER_OPTIONS_PAGE_SIZE,
    FetchFilterOptionsResult,
    FetchScopedFilterOptionsQuery,
    useFetchFilterOptionsPages
} from './filter-options-paging';

/**
 * The users a viewer can filter or pick from, narrowed to the teams already
 * chosen so the list matches what the rest of the filter is showing.
 */
export function useFetchUserFilterOptions(
    query: FetchScopedFilterOptionsQuery
): FetchFilterOptionsResult<FilterOption> {
    const { companyId, search, teamIds, enabled } = query;

    const { openApi } = useOpenApi();
    const openApiRef = useRef(openApi);
    useEffect(() => {
        openApiRef.current = openApi;
    });

    return useFetchFilterOptionsPages<FilterOption>(
        [USER_FILTER_OPTIONS_QUERY_KEY, { companyId, search, teamIds }],
        enabled,
        (offset) =>
            openApiRef.current.filters
                .getUserFilterOptions({
                    companyId,
                    limit: FILTER_OPTIONS_PAGE_SIZE,
                    offset,
                    search: search || undefined,
                    teamIds: teamIds.length > 0 ? teamIds : undefined
                })
                .then((response): FilterOptions => response.data.data.options)
    );
}
